import React, { Component } from 'react'
import { connect } from 'react-redux'
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './../../wrapper'
import { logInUserInfo } from '../../Actions/Users'
import { UsersList } from '../../Components/Users/usersModalforSuperAdmin'
import { checkPrivileges } from '../../Helpers'
import withRoutes from '../../HOC/HocRoutes';
// import { themeColors as themecolors } from '../../Reducers/Theme'

class Users extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isVisable: true,
      sessionCallTrack: true
    }
  }
  componentWillMount () {
    // this.props.dispatch(Notifications.removeAll())
    //   if (
    //     localStorage.getItem('adminToken')
    //   ) {
    //     window.location.replace('/login')
    //   }
  }

  controleSession = () => {
    if (localStorage.getItem('userInfo')) {
      fetch('/api/session', {
        method: 'DELETE'
      }).then(res => {
        let response = res.data
        if (response.ok) {
          this.props.navigate('/logout')
        }else{
          throw response
        }
      }).catch(e => {})
    }
  }

  render () {
    if (this.props.logInUser) {
    if (checkPrivileges('user')) {
     
        return (
          <Layout {...this.props} themecolors={this.props.themecolors}>
            <UsersList history={this.props.history} translate={this.props.translate}/>
          </Layout>
        )
     
    } else if (
      checkPrivileges('account') &&
      !checkPrivileges('device') &&
      !checkPrivileges('group')
    ) {
      this.controleSession()
      return null
    } else {
      return defaultPages.map(page => {
        if (checkPrivileges(page)) {
          if (page === 'device') {
            this.props.navigate(`/units`)
          } else {
            this.props.navigate(`/${page}s`)
          }
        }
      })
    }
  } 
    else {
      if (this.state.sessionCallTrack) {
        this.setState(
          {
            sessionCallTrack: false
          },
          () => {
            fetch('/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05', {
              headers: { Accept: 'application/json; odata=verbose' },
              params:{
                app: `3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05`,
                // host: fetchUrl
              }

            }).then(response => {
              if (response.ok) {
                response.json().then((res) => {
                  if (res.status === "success") {
                    // console.log("Stat====",res);
                    let userInfo = res.data;
                    this.props.setActiveLanguage(
                      userInfo?.attributes?.lang || "en"
                    );
                    this.props.dispatch(logInUserInfo(userInfo));
                  } else if (res?.statusCode === "440") {
                    window.location.replace("/login");
                  } else if (res.statusCode) {
                    var err = res?.message.split(":");
                    err[1] = err[1].replace(")", "");
                   
                      toast.error(
                       this.props.translate(err[1])
                    );
                    this.props.navigate("/login");
                  }
                });
              } else {
                this.props.navigate("/login");
                throw response;
              }
              }).catch(e => {
                toast.error(
                   'somethingWentWrong'
                )
              })
          }
        )
      }
      return null
    }
  }
}

const mapStateToProps = state => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  themecolors:state.themecolors
})

export default connect(mapStateToProps)(withRoutes(Users))

const defaultPages = ['account', 'device', 'group']
